import React from "react";

/**
 * Editorial cinematic page hero used across Blog, About, Tours,
 * Consultations and Partnership pages. Provides a consistent
 * background-image + eyebrow + headline + subtitle layout.
 */
export default function PageHero({
  image,
  eyebrow,
  title,
  titleBold,
  subtitle,
  align = "left", // "left" | "center"
  height = "78vh",
  minHeight = "520px",
  children,
}) {
  const alignClass =
    align === "center"
      ? "items-center text-center"
      : "items-start text-left";

  return (
    <section
      className="relative w-full overflow-hidden"
      style={{ height, minHeight }}
      data-testid="page-hero"
    >
      <img
        src={image}
        alt=""
        aria-hidden
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/30 to-[#FDFBF7]" />

      <div className="relative z-10 h-full max-w-7xl mx-auto px-6 md:px-12">
        <div className={`flex flex-col justify-end pb-20 h-full ${alignClass}`}>
          {eyebrow && (
            <div className="t-overline text-white/85 mb-4">{eyebrow}</div>
          )}
          {(title || titleBold) && (
            <h1
              className={`t-display text-white ${
                align === "center" ? "mx-auto" : ""
              } max-w-5xl`}
            >
              {title}
              {title && titleBold ? <br /> : null}
              {titleBold && <b>{titleBold}</b>}
            </h1>
          )}
          {subtitle && (
            <p
              className={`mt-6 text-white/85 text-base md:text-lg leading-relaxed ${
                align === "center" ? "mx-auto" : ""
              } max-w-2xl`}
            >
              {subtitle}
            </p>
          )}
          {children && <div className="mt-8">{children}</div>}
        </div>
      </div>
    </section>
  );
}
